'use client';

import * as React from 'react';
import { motion } from 'motion/react';

import { WhatsAppIcon } from '@workspace/ui/components/brand-icons';
import { Button } from '@workspace/ui/components/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@workspace/ui/components/tooltip';
import { APP_NAME } from '@workspace/common/app';

export function WhatsAppBubble(): React.JSX.Element {
  const [isVisible, setIsVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000); // Show after 3 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = (): void => {
    const phoneNumber = '+40799562479'; // Same number as in footer
    const message = encodeURIComponent(
      `Bună ziua! Sunt interesat de serviciile ${APP_NAME} și aș dori să aflu mai multe informații.`
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  if (!isVisible) return <></>;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.3
        }
      }}
      className="fixed bottom-4 right-4 z-50 sm:bottom-6 sm:right-6 md:bottom-8 md:right-8"
    >
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              onClick={handleWhatsAppClick}
              className="bg-foreground text-foreground hover:bg-foreground/90 h-12 w-12 rounded-full shadow-lg transition-all duration-200 hover:shadow-xl md:h-16 md:w-16"
              aria-label="Contactează-ne pe WhatsApp"
            >
              <WhatsAppIcon className="size-6 md:size-8" />
            </Button>
          </TooltipTrigger>
          <TooltipContent
            side="left"
            // className="mb-2 md:mb-0 lg:mb-2 xl:mb-0"
          >
            <p className="text-sm">Contactează-ne pe WhatsApp</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </motion.div>
  );
}
